import BaseListPresenter from "../../base/BaseListPresenter";

class TaskBoardPresenter extends BaseListPresenter {
  constructor(
    view,
    findObjectUseCase,
    countObjectUseCase,
    deleteObjectUseCase,
    upsertUseCase,
    exportCSVUseCase,
    addSchemaUseCase,
    updateSchemaUseCase,
    deleteSchemaUseCase,
  ) {
    super(view, findObjectUseCase, countObjectUseCase, deleteObjectUseCase);
    this.upsertUseCase = upsertUseCase;
    this.exportCSVUseCase = exportCSVUseCase;
    this.addSchemaUseCase = addSchemaUseCase;
    this.updateSchemaUseCase = updateSchemaUseCase;
    this.deleteSchemaUseCase = deleteSchemaUseCase;
    this.view = view;
  }

  // async findEmployee() {
  //   const currentUser = this.view.getCurrentUser();
  //   const employees = await this.findObjectUseCase.execute("employees", {
  //     where: { id: currentUser?.employee?.id },
  //     // keys: ["supervisor"],
  //   });

  //   return employees;
  // }

  init() {
    this.limit = 100;
    this.where = {};
    this.search = {};
    this.filter = {};
    this.include = ["employee", "employee.position"];
    this.keys = undefined; // if keys are specified, only those keys will be returned
    this.sort = { createdAt: -1 };
    this.progress = true;
    this.reset();
  }

  createQuery() {
    // console.log("employees: ", employees);
    const skip = (this.current - 1) * this.limit;
    const getCurrent = this.view.getCurrent();
    const empID = getCurrent?.employee?.id;
    const userID = getCurrent.id;

    const where = {
      $or: [
        { "employee.id": { $eq: empID } },
        {
          "workFlow.tasks.0.isAssignToRequestor": { $eq: true },
          $or: [
            { "workFlow.tasks.0.hierarchy.request.id": { $eq: empID } },
            {
              "supervisor.id": { $eq: empID },
            },
          ],
        },
        {
          "workFlow.tasks.0.isAssignToRequestor": { $eq: false },
          $or: [
            { "workFlow.tasks.0.hierarchy.approve.id": { $eq: empID } },
            { "workFlow.tasks.0.hierarchy.reject.id": { $eq: empID } },
            { "workFlow.tasks.0.hierarchy.request.id": { $eq: empID } },
            // { "employee.id": { $eq: empID } },
          ],
        },
      ],
    };
    const query = {
      limit: this.limit,
      skip: skip,
      where: { ...this.where, ...this.search, ...this.filter, ...where },
      include: this.include,
    };
    if (this.sort) {
      query.sort = this.sort;
    }
    const keys = this.keys || this.view.getKeys() || [];
    if (keys.length > 0) {
      query.keys = keys;
    }
    return query;
  }

  async findObjects() {
    const collection = this.view.getCollectionName();
    // const employees = await this.findEmployee();
    const query = this.createQuery();

    try {
      this.showProgress();
      this.findObjectUseCase.abort();
      const objects = await this.findObjectUseCase.execute(collection, query);
      // this.objects = this.objects.concat(objects);
      console.log("TESTobjects: ", objects);
      this.view.setObjects(objects);
      // this.view.setCurrent(this.current);
      this.hideProgress();
    } catch (error) {
      this.hideProgress();
      this.view.showError(error);
    }
    this.progress = false;
  }
}
export default TaskBoardPresenter;
